<template>
  <span class="text-left ez-dice">
    <a v-if="diceRoller" @click="showModal = true">
      <slot></slot>
    </a>
    <span v-else>
      <slot></slot>
    </span>
    <!--

    -->
    <ez-modal v-if="showModal" @close="showModal = false" size="m-dice">
      <h5 class="capitalize c7 clipper">{{name}}</h5>
      <hr>
      <div v-if="rolling" class="rolling text-center">
        <h1 class="roller">
          <img v-if="settingsDarkMode" class="fa fa-spin" src="/img/d20-light.png">
          <img v-else class="fa fa-spin" src="/img/d20-dark.png">
        </h1>
        <hr>
        <h5 class="rollmath">&nbsp;</h5>
      </div>
      <div v-else class="text-center">
        <h5 v-if="rollert" class="rollert" v-html="rollert"></h5>
        <h1>{{rollsults}}</h1>
        <hr>
        <h5 class="rollmath c7">{{rollmath}}</h5>
      </div>
    </ez-modal>
    <!--
    -->
  </span>
</template>

<script>
import Chance from "chance";
import modal from "@/mixins/vue-ez-modal";
import { mapGetters, mapState } from "vuex";

const REGEX_DICE = /\d*d\d+/gi;
const REGEX_BONI = / ?[-+/] ?\d+/gi;

export default {
  name: "vue-ez-modal-dice",
  mixins: [modal],
  props: ["name", "dice", "vantage"],
  data() {
    return {
      rolling: true,
      rollsults: "",
      rollmath: "",
      rollert: "",
      timer: null
    };
  },
  watch: {
    showModal: "roller"
  },
  computed: {
    ...mapGetters({ canEdit: "characters/canEdit" }),
    ...mapState({
      settingsDiceRoller: state => state.session.user.settings.diceRoller,
      settingsDarkMode: state => state.session.user.settings.darkMode
    }),
    diceRoller() {
      return (
        this.canEdit && this.settingsDiceRoller && !this.dice.startsWith("null")
      );
    }
  },
  methods: {
    roller() {
      clearTimeout(this.timer);
      this.rolling = true;
      this.rollsults = "";
      this.rollmath = "";
      this.rollert = "";
      this.timer = null;

      let chance = new Chance();
      let dice = this.dice.replace(/ /g, "");
      let _dicepool = dice.match(REGEX_DICE);

      let _bonus = 0;
      let regexBoni = dice.replace(REGEX_DICE, "").match(REGEX_BONI);
      if (regexBoni) {
        regexBoni.forEach(b => {
          _bonus += isNaN(parseInt(b)) ? 0 : parseInt(b, 10);
        });
      }

      let _rolls = [_dicepool.length];
      let _rollstotal = 0;

      for (let i = 0; i < _dicepool.length; i++) {
        let roll = chance.rpg(_dicepool[i].trim(), { sum: true });
        _rolls[i] = roll;
        _rollstotal += roll;
      }

      let _rollmath;

      if (_bonus > 0) {
        _rollmath = `[${_rolls.join("] + [")}] + ${_bonus} = ${_rollstotal +
          _bonus}`;
      } else if (_bonus < 0) {
        _rollmath =
          "[" +
          _rolls.join("] + [") +
          "] - " +
          _bonus * -1 +
          " = " +
          (_rollstotal + _bonus);
      } else {
        _rollmath = "[" + _rolls.join("] + [") + "] = " + _rollstotal;
      }

      if (
        _dicepool.length === 1 &&
        _dicepool[0] === "1d20" &&
        _rolls[0] === 20
      ) {
        this.rollert =
          '<span class="success"><span class="fa fa-flip-horizontal">🎉</span> Critical Success! 🎉</span>';
      }
      if (
        _dicepool.length === 1 &&
        _dicepool[0] === "1d20" &&
        _rolls[0] === 1
      ) {
        this.rollert =
          '<span class="danger"><span class="fa fa-flip-horizontal">☠</span> Critical Fail! ☠</span>';
      }

      let _rollsult = _rollstotal + _bonus;

      this.rollsults = _rollsult;
      this.rollmath = _rollmath;

      this.timer = setTimeout(() => {
        this.rolling = false;
      }, 500);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/_global";

h1 {
  margin-bottom: 0;
  font-size: 6rem;
}
.rollmath,
.rollert {
  margin-top: 0.5rem;
  margin-bottom: 0;
}
.roller {
  margin-top: -0.1em;
  margin-bottom: 0.1em;
}
hr {
  margin: 0;
}
.fa-spin {
  // opacity: 0.25;
  height: 72px;
  width: 72px;
  -moz-animation-duration: 1s;
  -o-animation-duration: 1s;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
}
</style>
